<template>
    <div class="history-container" id="history-parent">
        <div class="history-content-container">
            <div v-for="(product, key) of products.filter(prod => !prod.deleted)"
                 v-if="product.history.length > 0"
                 class="single-wrapper">
                <div data-toggle="collapse" :data-target="'#product-'+key" aria-expanded="false"
                     aria-controls="collapseOne" class="history-content-header" :id="'header-product-'+key">

                    <div>
                        <i class="fa fa-sort-up fa-1x"></i>
                        <button class="btn btn-link">{{product.history[0].value.length <= 30 ? product.history[0].value
                            : product.history[0].value.substring(0,37)+" ..."}}
                        </button>
                    </div>
                    <!-- <h5 class="mb-0">
                        ({{product.price.toFixed(2)}} € {{tvaMode}})
                    </h5> -->
                </div>
                <div class="history-content-wrap collapse" data-parent="#history-parent"
                     :id="'product-'+key">
                    <div v-for="item in product.history.filter(item => !item.isGlobal)" class="history-content">
                        <div>
                            <label v-html="item.label + ':'">{{ item.label }}:</label>
                            <span v-html="item.value">{{ item.value }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="price-container container-fluid total" v-if="hasPose || isSAV">
            <div class="row text-left">
                <div class="block-ht col-md-6">
                    <p class="right">Prix total HT :
                        <span style="font-weight:600;">{{totalPriceHt.toFixed(2)}}&nbsp;€</span>
                    </p>
                    <p v-for="(reductionAmount, reductionKey) in reductions" v-if="reductionKey != 0" class="right">Dont
                        remise HT de {{reductionKey}} % :
                        <span style="font-weight:600;">{{reductionAmount.toFixed(2)}}&nbsp;€</span>
                    </p>

                </div>
                <div class="block-ht col-md-6 text-right">
                    <p v-for="(total, unit) of priceByTva" v-if="unit !== '0'" class="right">Total TVA à {{unit}} % :
                        <span style="font-weight:600;">{{total.toFixed(2)}}&nbsp;€</span>
                    </p>
                </div>
            </div>

            <p class="total-price">Prix total : <span style="font-weight:600;">{{totalPrice.toFixed(2)}} € TTC</span>
            </p>

        </div>


        <div class="price-container-inline">
            <div class="price-container grey right-bordered" v-if="!hasPose && !isSAV">
                <p class="bold">Prix posé : <span style="font-weight:600;">{{prixPose.toFixed(2)}} €</span></p>
            </div>

            <div class="price-container grey" v-if="!hasPose && !isSAV">
                <p style="font-weight: 500;">Prix non posé : <span>{{prixNonPose.toFixed(2)}} €</span></p>
            </div>
        </div>


        <div class="user-history-buttons-container" :class="{'is-recap' : isRecap}">
            <div class="user-history-navigations-popup">
                <div class="user-recap-popups">
                    <div class="ccm-user-history right-bordered">
                 <span v-if="detailTitle" class="user-history-popup-trigger"
                       @click="fillAndOpenDefaultModalCCM()">{{detailTitle}}</span>
                    </div>
                    <div class="details-user-history">

                <span class="user-history-popup-trigger right-bordered" v-if="!isRecap && imageRecapDelais"
                      @click="fillAndOpenDefaultModal(imageRecapDelais)">Délais</span>
                        <span class="user-history-popup-trigger" v-if="!isRecap && imageRecapGaranties"
                              @click="fillAndOpenDefaultModal(imageRecapGaranties)">Garanties</span>
                    </div>
                </div>
                <change-step-user-history></change-step-user-history>
            </div>
            <span v-if="(hasPose || isSAV)  && isRecap" @click="toggleConfirm(true, false)" class="order-now">Commander dès maintenant</span>
        </div>
        <!-- Boutons / liens (sans redirection) -->

        <!--
            <span v-if="(hasPose || isSAV)  && isRecap" @click="toggleConfirm(true, false)" class="order-now">Commander dès maintenant</span>
        -->


        <div v-if="(hasPose || isSAV)  && isRecap" class="row row-recap mt-3 mb-3">

            <div class="col-md-4">
                <div class="button-recap">
                    <div>
                        <i class="fa fa-1x fa-file"></i><a
                            @click="toggleConfirm(false, false)" class="link-recap">Enregistrer mon projet</a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="button-recap">
                    <div>
                        <i class="fa fa-1x fa-file"></i><a @click="toggleConfirm(false, true)" class="link-recap">Être<br/>
                        contacté</a>
                    </div>
                </div>
            </div>

            <div class="col-md-4" v-if="!isSAV">
                <div class="button-recap">
                    <div>
                        <i class="fa fa-1x fa-file"></i><a @click="newProduct()" class="link-recap">Ajouter<br/>un
                        produit</a>
                    </div>
                </div>
            </div>

            <div class="col-md-4" v-if="isSAV">
                <div class="button-recap">
                    <div>
                        <i class="fa fa-1x fa-file"></i>&nbsp;
                        <a @click="newProductSav()" class="link-recap">Ajouter une réparation / un diagnostic</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-sm-12 bandeau" v-if="isRecap">
            <div class="row">
                <div class="col-md-4">
                    <h3>
                        <img class="img-picto" src="img/picto-fabrication-francaise.png"
                             alt="image pictogramme">Fabrication 100% Française
                    </h3>
                </div>
                <div class="col-md-4">
                    <h3>
                        <img class="img-picto" src="img/picto-suivi.png" alt="image pictogramme">
                        Suivi & Accompagnement
                    </h3>
                </div>
                <div class="col-md-4">
                    <h3>
                        <img class="img-picto" src="img/picto-sav.png" alt="image pictogramme">
                        SAV &
                        Garantie 10 ans
                    </h3>
                </div>
            </div>
        </div>
        <!-- Boutons / liens (sans redirection) -->


        <div class="popup-valid" :class="{'show-confirm' : showConfirm}">
            <ol>
                <li>Donnez un nom à votre devis</li>
                <li>Connectez-vous à votre compte ou inscrivez-vous</li>
                <li>Retrouvez tous vos devis dans votre compte</li>
                <li>Transformez vos devis en commande</li>
                <li>Validez votre commande en ligne</li>
            </ol>
            <form>
                <label for="name"></label>
                <input type="text" name="name" id="name" v-model="projectName" placeholder="Nom de votre devis"/>
                <div class="button-list">
                    <button class="btn" @click.prevent="toggleConfirm">Annuler</button>
                    <button class="btn main" @click.prevent="exportPlayload(order, transmit)">Confirmer</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import PriceManager from "./PriceManager";
    import ChangeStepUserHistory from "../ChangeStepUserHistory";

    export default {
        name: "UserHistory",
        data() {
            return {
                preventSave: null,
                showConfirm: false,
                projectName: this.$store.state.currentProjectName,
                order: false,
                priceByTva: {},
                totalReduction: 0,
                reductions: {},
                totalPrice: 0,
                totalPriceHt: 0,
                transmit: false,

            }
        },
        components: {ChangeStepUserHistory, PriceManager},


        watch: {
            projectName: function (newVal, oldVal) {
                this.$store.dispatch('setProjectName', newVal);

            },

            products() {
                if (this.isRecap) {
                    //this.totalPriceHtFunc();
                    //this.totalPriceFunc()
                }
            },

            '$store.state.refreshInc'() {
                this.totalPriceHtFunc();
                this.totalPriceFunc()
            },

            hasPose() {
                this.totalPriceHtFunc();
                this.totalPriceFunc()
            },

            '$store.state.livraisonPercent'() {
                this.totalPriceHtFunc();
                this.totalPriceFunc()
            },

            '$store.state.poseExtra'() {
                this.totalPriceHtFunc();
                this.totalPriceFunc()
            },
            '$route': function () {
                this.totalPriceHtFunc();
                this.totalPriceFunc()
            },

            isRecap() {
            }
        },

        mounted() {
            this.totalPriceHtFunc();
            this.totalPriceFunc()
        },

        computed: {
            siteColor() {
                return this.$store.state.siteInfos.Couleur
            },
            isSAV() {
                return this.$store.state.family.Prefix === "sav"
            },
            isRecap() {
                return parseInt(this.$route.params.step) === Object.keys(this.$store.state.steps).length
            },
            hasPose() {
                return this.$store.state.globalAnswers.some(global => global.variable === "pose")
            },
            products() {
                return this.$store.state.products.filter(product => !product.deleted)
            },
            price() {
                return this.$store.state.price
            },
            currentProductKey() {
                return this.$store.state.currentProductKey
            },

            prixPose() {
                let total = 0;

                Object.keys(this.products).forEach((key) => {
                    let prod = this.products[key];
                    let basePrice = prod.price;
                    if (basePrice > 0) {
                        let reduction = parseInt(this.$store.state.reduction[this.products[key].productType]);

                        total += parseFloat(basePrice);
                        total += parseFloat(this.$store.state.poseExtra) / this.products.length;

                        total -= total * reduction / 100;

                        let tvaKey = prod.productType === "sav" ? "sav_" + key : prod.productType;
                        tvaKey = prod.productType === "vr" ? "vr_" + key : tvaKey;

                        if (this.$store.state.tauxTvas[tvaKey] !== undefined) {
                            let tvaForProd = this.$store.state.tauxTvas[tvaKey].find(el => el.pose);
                            if (tvaForProd !== undefined)
                                total += parseFloat(tvaForProd.Taux) / 100 * total;
                        }
                    }
                });
                return total;
            },
            prixNonPose() {
                let total = 0;
                Object.keys(this.products).forEach((key) => {

                    let prod = this.products[key];
                    let basePrice = prod.price;


                    if (basePrice > 0) {

                        total += basePrice;
                        let reduction = parseInt(this.$store.state.reduction[this.products[key].productType]);
                        total -= total * reduction / 100;


                        let tvaKey = prod.productType === "sav" ? "sav_" + key : prod.productType;
                        tvaKey = prod.productType === "vr" ? "vr_" + key : tvaKey;

                        if (this.$store.state.tauxTvas[tvaKey] !== undefined) {
                            let tvaForProd = this.$store.state.tauxTvas[tvaKey].find(el => !el.pose);
                            if (tvaForProd !== undefined)
                                total += parseFloat(tvaForProd.Taux) / 100 * total;
                        }
                    }
                });
                return total
            },

            tvaMode() {
                return this.$store.state.tvaMode
            },

            apiUrl() {
                return this.$store.state.apiUrl
            },
            siteInfos() {
                return this.$store.state.siteInfos
            },
            imageRecapDelais() {
                if (this.$store.state.families) {
                    let famille = this.$store.state.families.find((e) => {
                        return e.Prefix === this.$store.state.productType
                    });
                    if (famille)
                        return famille.image_recap_delais;
                }
                return false;
            },
            imageRecapGaranties() {
                if (this.$store.state.families) {
                    let famille = this.$store.state.families.find((e) => {
                        return e.Prefix === this.$store.state.productType
                    });
                    if (famille)
                        return famille.image_recap_garanties;
                }
                return false;
            },

            detailImg() {
                return this.$store.state.detail_img
            },

            detailTitle() {
                return this.$store.state.detail_title
            },
        },

        methods: {

            fillAndOpenDefaultModalCCM() {
                let modal = $('#basicModal');
                modal.find('h5').text("");
                modal.find('img').attr('src', this.detailImg);
                modal.find('.extra-popup').html('')
                modal.modal('show');

            },

            fillAndOpenDefaultModal(imageUrl) {
                imageUrl = `${this.apiUrl}/${imageUrl}`
                let modal = $('#basicModal');
                modal.find('h5').text("");
                modal.find('img').attr('src', imageUrl);
                modal.find('.extra-popup').html("");
                modal.modal('show');
            },
            totalPriceHtFunc() {
                let total = 0;

                Object.keys(this.products).forEach((key) => {

                    let prod = this.products[key];
                    //product price without TVA
                    let prodTotal = prod.price;

                    prodTotal += prodTotal * this.$store.state.livraisonPercent / 100;
                    // Product Price with POSE Price
                    if (this.$store.state.globalAnswers.some(global => global.variable === "pose" && global.value))
                        prodTotal += this.$store.state.poseExtra / this.products.length;

                    //handles reductions
                    let reduction = parseInt(this.$store.state.reduction[prod.productType]);

                    if (!isNaN(reduction))
                        prodTotal -= prodTotal * reduction / 100;


                    total += prodTotal

                });
                this.totalPriceHt = total
            },

            totalPriceFunc() {
                let total = 0;
                this.priceByTva = {};
                let pricesByProds = {};

                this.reductions = {};
                this.totalReduction = 0;

                Object.keys(this.products).forEach((key) => {
                    let prod = this.products[key];
                    //product price without TVA
                    let prodTotal = prod.price;

                    prodTotal += prodTotal * this.$store.state.livraisonPercent / 100;

                    // Product Price with POSE Price
                    if (this.$store.state.globalAnswers.some(global => global.variable === "pose" && global.value))
                        prodTotal += this.$store.state.poseExtra / this.products.length;


                    //handles reductions
                    let reduction = parseInt(this.$store.state.reduction[prod.productType]);
                    if (!isNaN(reduction)) {

                        this.reductions[reduction] = this.reductions[reduction] || 0;

                        this.reductions[reduction] += prodTotal * reduction / 100;

                        this.totalReduction += prodTotal * reduction / 100;

                        prodTotal -= prodTotal * reduction / 100;
                    }
                    let tvaKey = prod.productType === "sav" ? "sav_" + key : prod.productType;
                    tvaKey = prod.productType === "vr" ? "vr_" + key : tvaKey;

                    if (this.$store.state.tauxTvas[tvaKey] !== undefined) {
                        let tvaForProd = this.$store.state.tauxTvas[tvaKey].find(el => this.$store.state.globalAnswers.some(global => global.variable === "pose" && global.value) == el.pose)
                        if (tvaForProd === undefined)
                            tvaForProd = this.$store.state.tauxTvas[tvaKey][0];


                        if (this.priceByTva && this.priceByTva[tvaForProd.Taux] === undefined) {
                            this.priceByTva[tvaForProd.Taux] = 0
                        }

                        let tauxTva = parseFloat(tvaForProd.Taux);

                        this.priceByTva[tvaForProd.Taux] += prodTotal * tauxTva / 100;
                        prodTotal += prodTotal * tauxTva / 100;
                    }

                    pricesByProds[key] = prodTotal;
                    total += prodTotal

                });
                this.$store.dispatch('changePriceByProds', pricesByProds);
                this.totalPrice = total;
            },

            toggleConfirm(order, transmit) {
                this.showConfirm = !this.showConfirm;
                if (order !== undefined) {
                    this.order = order;
                }

                if (transmit !== undefined) {
                    this.transmit = transmit;
                }


            },
            exportPlayload(order, transmit) {

                this.$store.dispatch('exportPlayload', {
                    order: order,
                    transmit: transmit,
                    pricesCompiled: {
                        totalPrice: this.totalPrice,
                        totalPriceHt: this.totalPriceHt,
                        priceByTva: this.priceByTva,
                        totalReduction: this.totalReduction,
                        reductions: this.reductions,
                    }
                })
            },

            newProduct() {
                this.$store.dispatch('newProduct');
                this.$router.push('/preconstructor');
            },
            async newProductSav() {
                await this.$store.dispatch('resetStateWithProduct', true);
                await this.$store.dispatch('newProduct');
                await this.$store.dispatch("setProductType", "sav");

                await this.$store.dispatch('loadQuestions');

                this.$router.push('/constructor/sav/etape1')
            },
        }
    }


</script>

<style scoped>


    .user-history-buttons-container.is-recap {
        display: flex;
    }

    .user-history-buttons-container.is-recap > * {
        width: 50%;
    }

    .user-history-buttons-container > * * {
        width: 100%;
    }


    .user-history-buttons-container.is-recap .order-now {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .user-history-buttons-container.is-recap .user-recap-popups {
        display: initial;
        width: 100%;
    }

    .user-history-buttons-container.is-recap .user-recap-popups > div {
        width: 100%;
    }


    .user-recap-popups {
        display: flex;
        width: 100%;
    }

    .user-recap-popups > div {
        width: 50%;
    }

    .recapResponsive .user-recap-popups > div {
        width: 100%;
    }

    .recapResponsive .change-btn-userhistory button {
        width: 100%;
    }

    .recapResponsive .order-retour-container > div {
        width: 50%;
    }


    .details-user-history {
        display: flex;
    }

    .details-user-history span {
        width: 50%;
    }

    .price-container.container-fluid.total {
        width: 100%;
    }

    .user-history-popup-trigger {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        min-height: 65px;
        background: rgb(0, 0, 0);
        color: #ffffff;
        font-size: 15px;
        cursor: pointer;
        border-top: white 2px solid;
        border-bottom: white 2px solid;
        font-weight: 500;

    }

    .right-bordered {
        border-right: white 2px solid;
    }

    .left-bordered {
        border-left: white 2px solid;
    }


    .garanties-popup-trigger {
        background: #0a0c0d;
        color: #ffffff;
        margin-left: 0 !important;
    }

    .total-price {
        width: 100%;
        text-align: left;
        font-size: 18px;
        margin-top: 15px;
    }

    .total-price span {
        float: right;
    }

    .block-ht {
        font-size: 14px;
    }

    .block-ht span {
        font-size: 15px;
    }

    div[aria-expanded="false"] .fa-sort-up {
        transform: rotate(180deg);
        transition: all .3s;
    }

    div[aria-expanded="true"] .fa-sort-up {
        transform: rotate(0deg);
        transition: all .3s;
    }

    .popup-valid.show-confirm {
        display: block;
    }

    .popup-valid {
        display: none;
        width: 40%;
        margin: 50px auto;
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.4);
        background-color: #ffffff;
        padding: 10px;
        text-align: center;
        font-family: sans-serif;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
    }

    .popup-valid .title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .popup-valid form {
        width: 90%;
        margin: 0 auto;
    }

    .popup-valid form label {
        display: none;
    }

    .popup-valid form input {
        height: 35px;
        width: 100%;
        padding: 5px 10px;
        display: block;
        box-sizing: border-box;
    }

    .popup-valid .button-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
    }
    .popup-valid .button-list .btn {
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 16px;
        line-height: 1.5;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        background-color: #d8d8d8;
        border-radius: 0;
    }

    .popup-valid .button-list .btn:hover {
        cursor: pointer;
    }

    .popup-valid .button-list .btn.main {
    }

    .popup-valid .button-list .btn:hover.main {
        background-color: #c4c4c4;
    }

    .popup-valid .button-list .btn:hover {
        background-color: #c4c4c4;
    }

    .bgwhite {
        background-color: #fff;
    }

    .link-recap {
        text-decoration: underline !important;
        font-weight: bold;
        cursor: pointer;
        color: #2d2d2d !important;
        font-size: 16px;
    }

    .order-now {
        justify-content: center;
        /* background-color: rgb(253, 198, 0); */
        color: #000000;
        padding: 15px 10px;
        letter-spacing: 1px;
        font-weight: bold;
        border-top: 1px solid #fff;
        cursor: pointer;
        text-transform: uppercase;
        display: flex;
        align-items: center;
    }

    .single-wrapper {
        /* margin-bottom: 2px; */
    }

    .single-wrapper button {
        color: #000;
    }

    .btn-link {
        cursor: pointer;
    }

    button.btn-link::before {
        content: "";
        width: 0 !important;
    }

    h5 {
        font-size: 15px;
        color: black;
        font-weight: bold;
        cursor: pointer;
    }

    .controls {
        width: 20%;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .controls i {
        cursor: pointer;
        font-size: 1.2em;
    }

    .controls i:hover {
    }

    .history-content-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        border-bottom: 2px solid #fff;
        /* height: 40px; */
        padding: 2px 10px;
    }

    .history-container {
        /* transform: translateY(-40%); */
        position: relative;
        display: flex;
        flex-flow: nowrap column;
        /* background: #f5f4f4; */
    }

    p {
        margin: 0;
    }

    .history-content-container {
        width: 100%;
        text-align: left;
        overflow: auto;
        /* padding: 5px 15px; */
        display: flex;
        flex-direction: column-reverse;
        height: auto;
        margin-top: 2px;
    }

    .history-content-wrap {
        width: 100%;
        text-align: left;
        padding: 15px 15px 35px;
        overflow-y: scroll;
        border-top: 2px solid #efefef;
        height: 15vh;
    }

    .history-container label {
        display: inline-block;
        font-weight: bold;
        margin-right: 4px;
    }

    .circle i {
        display: inline-block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
    }

    .price-container-inline {
        display: flex;
    }

    .price-container {
        padding: 20px;
        border-top: 1px solid #fff;
        min-height: 40px;
        width: 50%;
    }

    .price-container p {
        color: #2d2d2d;
    }

    .price-container p.reduction {
        color: #2d2d2d;
        margin-bottom: 0;
        padding: 10px;
        font-size: 1em;
    }

    .price-container.grey {
        background-color: rgb(196, 196, 197);
    }

    .row-recap > div {
        margin-bottom: 1em;
    }

    .recapResponsive .order-retour-container {
        display: flex;
    }

    @media (min-width: 768px) {
        .row-recap > div {
            padding: 0;
            flex: 0 0 31%;
            max-width: 31%;
        }

        .row-recap {
            margin-right: 0;
            margin-left: 0;
            justify-content: space-between;
        }
    }

    .button-recap {
        padding: 15px 10px;
        background: #ffffff;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1em;

    }

    .button-recap > div {
        display: flex;
        flex-direction: column;
    }

    .button-recap i {
        padding-bottom: 5px;
    }

    .button-recap a.link-recap {
        color: #000000 !important;
        text-decoration: none !important;
        word-break: break-word;
    }

    .bandeau {
        display: none;
    }

    @media screen and (min-width: 1024px) and (max-width: 1400px) {
        .popup-valid {
            width: 60%;
        }
    }

    .price-container p {
        color: #2d2d2d;
    }

    @media screen and (max-width: 1200px) {


        .price-container p {
            font-size: 16px;
        }

        .price-container {
            padding: 10px;
        }

        .user-history-popup-trigger {
            font-size: 16px;
        }

        .link-recap {
            font-size: 16px;
        }

        .button-recap {
            padding: 10px 10px;
        }

        .order-now {
            font-size: 16px;
        }
    }

    @media screen and (max-width: 767px) {
        .price-container p {
            text-align: left;
        }

        .total-price span {
            text-align: left;
            float: initial;
        }
    }

    @media screen and (max-width: 1023px) {

        .row-recap {
            margin: 0 auto;

        }

        .popup-valid {
            position: fixed;
            width: 80%;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            margin: 0;
        }

        .history-content-wrap {
            width: 100%;
            text-align: left;
            padding: 15px 15px 10px;
            overflow-y: scroll;
            border-top: 2px solid #efefef;
            height: 35vh;
        }

        .bandeau {
            display: block;
            padding: 25px 10px;
            width: auto;
        }

        .img-picto {
            width: 13%;
            margin-right: 10px;
        }

        .bandeau .col-md-4 {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;

        }

        .bandeau h3 {
            font-size: 1.163rem;
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            padding: 10px;
            font-weight: bold;
            line-height: initial;
        }

    }
</style>
